import React from "react";
import iBtn from "assets/icons/ibtn.svg";

interface DisclaimerProps {
  bg?: boolean;
}

export const Disclaimer: React.FC<DisclaimerProps> = ({ bg }) => {
  return (
    <div className={`flex flex-col  sm:flex-row items-start gap-1 md:gap-3 my-6 p-0 ${bg ? "bg-gray-50" : ""} rounded-lg`}>
      <div className="font-bold text-xs m:-text-base text-gray-900 underline">Disclaimer:</div>
      <div className="flex items-start gap-2">
        <img src={iBtn} className="w-5 h-5 text-gray-500 flex-shrink-0" />
        <p className=" text-xs md:text-[13px] text-gray-700 font-semibold">Please note that correcting inaccurate or missing information related to your policy may result in a change in premium or, in certain cases, termination of the policy contract.</p>
      </div>
    </div>
  );
};
